import React, { useState, useEffect, Fragment } from "react";
import { API_URL } from "../helpers";
import Alert from "../components/Alert";
import Input from "../components/Input";
import Checkbox from "../components/Checkbox";
import Msg from "../components/Msg";
import Submit from "../components/Submit";

const Form4 = ({ token, update }) => {
  const [errors, setErrors] = useState([]);
  const [names, setNames] = useState({
    token,
  });
  const [msg, setMsg] = useState({});
  const [alert, setAlert] = useState({
    type: "working",
    text: "",
  });

  useEffect(() => {
    init();

    // eslint-disable-next-line
  }, []);

  const init = async () => {
    const url = new URL(`${API_URL}/auth/charityForm4Init`);
    const params = {
      token: names.token,
    };
    url.search = new URLSearchParams(params);

    try {
      const response = await fetch(url, {
        method: "GET",
        cache: "no-store",
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        handleUpdate("youtubeId", json.youtubeId);
        handleUpdate("title", json.title);
        setAlert({});
      } else {
        setAlert({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setAlert({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  const handleUpdate = (name, value) => {
    setNames((names) => ({ ...names, [name]: value ? value : "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrors([]);
    setMsg({
      type: "working",
      text: "",
    });

    const url = new URL(`${API_URL}/auth/charityForm4`);
    let data = new FormData();
    Object.entries(names).forEach(([key, value]) => {
      if (key === "remove") {
        data.append(key, value ? "1" : "0");
      } else {
        data.append(key, value);
      }
    });

    try {
      const response = await fetch(url, {
        method: "POST",
        body: data,
      });
      const json = await response.json();
      if (json && json.resp === 1) {
        update("form", 0);
      } else {
        setErrors(json.fields);
        setMsg({
          type: "error",
          text: json.text,
        });
      }
    } catch (error) {
      setMsg({
        type: "error",
        text: "An error has occurred.",
      });
    }
  };

  return (
    <Fragment>
      {alert.type ? (
        <Alert data={alert} />
      ) : (
        <form
          method="post"
          action="/"
          onSubmit={(e) => handleSubmit(e)}
          className="well"
        >
          <h3 style={{ marginTop: "0" }}>Add YouTube Video</h3>

          <p>
            If you would like to embed a public YouTube video on your donation
            form, please enter its ID below.
          </p>

          <div className="form-group">
            <Input
              name="youtubeId"
              label="YouTube Video Id (ex. 04s-2awcV0o)"
              reqd={true}
              value={names.youtubeId || ""}
              update={handleUpdate}
              errors={errors}
            />
            <Input
              name="title"
              label="Optional Title"
              reqd={false}
              value={names.title || ""}
              update={handleUpdate}
              errors={errors}
            />
          </div>

          <div className="form-group checkbox" style={{ marginTop: "10px" }}>
            <Checkbox
              name="remove"
              label="Check if you would like to remove your existing video."
              checked={names.remove || false}
              click={handleUpdate}
            />
          </div>

          <div className="msg-submit">
            {msg.type && <Msg data={msg} />}

            <div
              className={
                msg.type === "working" || msg.type === "success"
                  ? "hidden"
                  : "submit-container"
              }
            >
              <Submit path="" left="" submit="Submit Changes" />
            </div>
          </div>
        </form>
      )}
    </Fragment>
  );
};

export default Form4;
